module.exports = __webpack_public_path__ + "img/9788991095885.3a761540.jpg";